
<template>
  <div class="B103">
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />

    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tr>
                <td>身分證統一編號</td>
                <td>
                  <input
                    type="text"
                    size="10"
                    maxlength="10"
                    v-model="form.idn"
                  />
                </td>
              </tr>
              <tr>
                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    size="40"
                    maxlength="49"
                    v-model="form.name"
                  />
                </td>
              </tr>
              <tr>
                <td colspan="2" class="f_center">
                  <input
                    type="submit"
                    class="btn"
                    value="查詢"
                    @click="
                      () => {
                        this.form.currentpage = 1;
                        this.form.pagesize = 10;
                        this.doQuery();
                      }
                    "
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="重填"
                    @click="doClear()"
                  />
                </td>
              </tr>
            </table>
          </div>
          <!-- <div align="center">
            <p>
              <input
                type="submit"
                class="btn"
                value="查詢"
                @click="doQuery()"
              />
              <input
                type="submit"
                class="btn"
                value="重填"
                @click="doClear()"
              />
            </p>
            <p>&nbsp;</p>
          </div> -->
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tr>
              <td></td>
              <td v-if="grid && grid.paginaiton" align="right">
                <input
                  type="button"
                  value="<<"
                  class="btn"
                  style="height: 28px"
                  @click="form.currentpage = grid.paginaiton.pageNo - 1"
                  v-show="grid.paginaiton.pageNo > 1"
                />
                <span
                  v-for="(data, index) in grid.paginaiton.pages"
                  :key="index"
                  style="cursor: pointer"
                  :style="
                    grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                  "
                  @click="form.currentpage = parseInt(data)"
                >
                  {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
                </span>
                <input
                  type="button"
                  class="btn"
                  value=">>"
                  style="height: 28px"
                  v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                  @click="form.currentpage = grid.paginaiton.pageNo + 1"
                />
                ［每頁<input
                  type="text"
                  v-model.number.lazy="form.pagesize"
                  size="2"
                />

                <input type="button" class="btn" value="筆" />，第<input
                  type="text"
                  v-model.number.lazy="form.currentpage"
                  size="2"
                />
                <input type="button" class="btn" value="頁" />，共
                {{ grid.paginaiton.totalPage }} 頁
                {{ grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>操作</th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('NAME', Sort);
                          }
                        "
                        >姓名</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('IDN', Sort);
                          }
                        "
                        >身分證字號</u
                      >
                    </th>
                    <th>保險含括年度</th>
                    <th>聲明上傳日</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="列印"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="doPrint(data)"
                      />
                    </td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.idn }}</td>
                    <td>{{ data.year }}</td>
                    <td>{{ data.datetime }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>

    <PdisFooter />

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import {
  B103_SearchGrid,
  B103_ReSearchGrid,
  B103_print,
  USR_ACT_LOG,
} from "@/service/api.js";
import { getMenu, getMenuIndex, logOut } from "@/config/util.js";

export default {
  name: "B103",
  data: function () {
    return {
      pageData: {
        MenuIndex: 2,
        MenuName: "",
        ServiceUnit: "PDIS",
        PrgName: "B103",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      Order: "",
      Sort: "",
      form: {
        idn: "",
        name: "",
        pagesize: 10,
        currentpage: 1,
      },
      grid: { gridDatas: [], paginaiton: [] },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
  },
  methods: {
    doQuery: function () {
      const self = this;
       //清空
      self.Order = "";
      self.Sort = "";
      let postData = {
        idn: self.form.idn,
        name: self.form.name,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      B103_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "DATETIME";
          self.Sort = "DESC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }

      let postData = {
        idn: self.form.idn,
        name: self.form.name,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      B103_ReSearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    doClear: function () {
      const self = this;
      self.form.idn = "";
      self.form.name = "";
    },
    doPrint: function (data) {
      const self = this;

      //2025-02-20新增執行按鈕寫Log
      let usr_act_log = {
        Id: self.loginInfo.id,
        PrgCode: 'B103',
        ActCd: '列印',
        FunName: 'doPrint',
        ServiceUnit: self.pageData.ServiceUnit,
        Log: '姓名: ' + data.name + ', seqno: ' + data.seqnO_I,
      };
      USR_ACT_LOG(usr_act_log);

      let postData = {
        SEQNO_I: data.seqnO_I,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "列印",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      B103_print(postData).then((rData) => {
        let link = document.createElement("a");
        link.download = self.form.name + "保險含括";
        link.href = "data:application/pdf;base64," + rData;
        link.click();
      });
    },
  },
  created() {
    const self = this;
    const Menu = getMenu(self.pageData.PrgName);
    //RoleAuthorizeMenu
    if (Menu) {
      self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    this.doQuery();
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
